import Blockly from "blockly";
import BlocklyJs from "blockly/javascript";
import { BlocklyJsOperator } from "common/blockly";
import { showAnswerSnippetByOnly } from "features/courses/program/game/blockly/uitls";

export const InitShowLabelTextBlock = () => {
  Blockly.Blocks["show_label_text_block"] = {
    max: 1,
    init: function () {
      this.jsonInit({
        type: "show_label_text_block",
        message0: "%1%{BKY_DISPLAY_EVENT}",
        args0: [
          {
            type: "input_value",
            name: "value",
            check: "String",
          },
        ],
        previousStatement: null,
        nextStatement: null,
        style: "text_blocks",
      });
    },
  };
  BlocklyJs["show_label_text_block"] = function (block: Blockly.Block) {
    const value = BlocklyJs.valueToCode(
      block,
      "value",
      BlocklyJsOperator.ORDER_NONE
    );
    const result = value === "'あ'";
    return `
      highlightBlock("${block.id}", true);
      target = document.getElementById("course-program-label-1");
      target.innerText = ${value};
      sound();
      target.style.opacity = "1";
      target.style.transform = "scale(1)";
      await sleep(700);
      ${showAnswerSnippetByOnly(result)}
      await sleep(700);
      highlightBlock("${block.id}", false);
      setSuccess(${result});
      setGameOver(true);
    `;
  };
};
